module.exports = __webpack_public_path__ + "static/media/user-icon.ee5bf551.svg";